// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list[data-v-c8fa14c4] {\n  background: #171921;\n  border: 1px solid #4A4A4A;\n}\n[data-v-c8fa14c4] .v-list-item__content {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
